<script lang="ts" setup>
import postOrderNumberLookup from '@consumer/services/api/postOrderNumberLookup'

const orderNumber = ref('')

const errorMessage = ref<string | null>(null)

const successMessage = ref<string | null>(null)

const onSubmit = () => {
  errorMessage.value = null
  successMessage.value = null
  postOrderNumberLookup(orderNumber.value, 'gifter').then((data) => {
    successMessage.value = data.message
  }).catch((error) => {
    errorMessage.value = error
  })
}
</script>

<template>
  <form
    class="mt-6"
    @submit.prevent="onSubmit"
  >
    <div class="flex flex-col lg:flex-row lg:items-end gap-6">
      <div class="w-full" style="max-width: 300px;">
        <GTextInput
          v-model="orderNumber"
          label="Enter the 9 to 11 character order number"
          placeholder="Ex.: QABCDEFGH"
        />
      </div>
      <div class="w-full" style="max-width: 200;">
        <GButton
          primary
          size="large"
          name="find-order-button"
          label="Next"
          type="submit"
        />
      </div>
    </div>
    <div v-if="errorMessage" class="text-red-base mt-4">
      {{ errorMessage }}
    </div>
    <div v-else-if="successMessage" class="mt-4">
      {{ successMessage }}
    </div>
  </form>
</template>
